export default __webpack_public_path__ + "static/media/element_42.88297d26.avif";